export default function mobileNav () {
  const subnavTriggers = document.querySelectorAll('.js-mobile-subnav-trigger')

  subnavTriggers.forEach(trigger => {
    trigger.addEventListener('click', (ev) => {
      ev.preventDefault()
      const subnav = trigger.nextElementSibling
      const isOpen = subnav.classList.contains('visible')
      subnav.classList.toggle('visible', !isOpen)
      trigger.classList.toggle('active', !isOpen)
    })
  })
}
